import { render, staticRenderFns } from "./CallApi.vue?vue&type=template&id=37f47000&"
import script from "./CallApi.vue?vue&type=script&lang=js&"
export * from "./CallApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports